import styled from "styled-components";

export const StyledMintSlider = styled.div `
  width: 100%;
  display: flex;
  height: 100%;
  background: transparent;
  align-items: center;
  margin-top: 10px;

  input[type="range"] {
    width: 100%;
    appearance: none;
    background: url("/assets/backggroundimageslider.svg");
    background-size: cover;
    background-repeat: no-repeat;
    height: 100%;
    margin: 0;
  }

  //track customization
  input[type="range"]::-webkit-slider-runnable-track {
    height: 8px;
    background: white;
    border-radius: 0px;
  }
  
  input[type="range"]::-moz-range-track {
    height: 8px;
    background: white;
    border-radius: 0px;
  }

  //thumb customization
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;    
    position: relative;
    background: ${({theme}) => theme.background};
    width: 19px;
    height: 100px;
    top: -46px;
    border-radius: 0px;
    border-color: white;
    border-style: solid;
    border-width: 4px 8px;
    box-shadow: 0 0 0 2px ${({theme}) => theme.background};

    @media (max-width: 1770px) {
      width: 15px;
      height: 66px;
      top: -29px;
      border-radius: 0px;
      border-color: white;
      border-style: solid;
      border-width: 3px 6px;
    }

    @media (max-width: 1440px) {
      width: 15px;
      height: 50px;
      top: -21px;
      border-radius: 0px;
      border-color: white;
      border-style: solid;
      border-width: 3px 6px;
    }

    @media (max-width: 1160px) {
      width: 12px;
      height: 46px;
      top: -19px;
      border-radius: 0px;
      border-color: white;
      border-style: solid;
      border-width: 3px 5px;
    }
    
    @media (max-width: 850px) {
      width: 10px;
      height: 32px;
      top: -12px;
      border-radius: 0px;
      border-color: white;
      border-style: solid;
      border-width: 2px 4px;
    }
  }

  input[type="range"]::-moz-range-thumb {
    height: 15px;
    width: 15px;
    background-color: transparent;
    border-radius: 0px;
    border: 1px solid #f50;
  }
`
